import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator"]
  static values = {
    url: String,
    page: { type: Number, default: 1 },
    loading: { type: Boolean, default: false }
  }

  connect() {
    this.intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loadingValue) {
          this.loadMore()
        }
      })
    }, {
      rootMargin: '100px', // Start loading when indicator is 100px away
    })

    if (this.hasIndicatorTarget) {
      this.intersectionObserver.observe(this.indicatorTarget)
    }
  }

  disconnect() {
    this.intersectionObserver.disconnect()
  }

  loadMore() {
    if (this.loadingValue) return

    this.loadingValue = true

    const nextPage = this.pageValue + 1
    const separator = this.urlValue.includes('?') ? '&' : '?'
    const url = `${this.urlValue}${separator}page=${nextPage}`

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Failed to fetch more content')
      }
    })
    .then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")

      // Process each turbo-stream element
      doc.querySelectorAll('turbo-stream').forEach(streamElement => {
        Turbo.renderStreamMessage(streamElement.outerHTML)
      })

      this.pageValue = nextPage
    })
    .catch(error => console.error('Error:', error))
    .finally(() => {
      this.loadingValue = false
    })
  }
}
